import { Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';
import { Fragment, useContext } from 'react';
import logo from '../../assets/images/logo/logo.svg';
import { GlobalContext } from '../../context/Provider';
import { LanguageKeys } from '../../context/providerInterface';
Font.register({
    family: 'bold',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
    fontWeight: 'bold'
});

Font.register({
    family: 'medium',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf",
});

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
    },
    w_100: {
        width: '100%',
    },
    logo: {
        maxWidth: 100,
        height: 40,
        objectFit: 'cover',
    }
});


const InvoiceFooter = ({ data }:any) => {

    const { authState, language_data } = useContext(GlobalContext);

    // translation helper
    const t = (key: keyof LanguageKeys, fallback: string) =>
        language_data?.[authState?.lang]?.[key] || fallback;

    return (
        <Fragment>

            {/* Authorized Signatory */}
            <View style={styles.container}>
                <Text
                    style={[
                        styles.w_100,
                        { textAlign: 'right', marginTop: 20 }
                    ]}
                >
                    {t('common_authorized', 'Authorized')} {t('common_signatory', 'Signatory')}
                </Text>
            </View>

            <View style={{ borderBottom: '1px solid #000', marginTop: 5, marginBottom: 10 }} />

            {/* Footer Content */}
            <View style={[styles.container, { marginTop: 40, marginBottom: 40 }]}>

                {/* Left Side */}
                <View style={{ width: '100%' }}>

                    <Image src={logo} style={styles.logo}  />

                    <Text style={{ marginTop: 5 }}>
                        {t('common_contact', 'Contact')} {t('common_henceforth', 'Henceforth')} {t('common_commerce', 'Commerce')}:
                        {' '} www.henceforthsolutions.com
                    </Text>

                </View>

                {/* Right Side */}
                {/* <View style={{ width: '20%' }}>

                    <Text style={{ textAlign: 'right', fontSize: 13 }}>
                        {t('common_not_more_than', 'Not more than')}
                    </Text>

                    <Text style={{ textAlign: 'right', marginTop: 5 }}>
                        {t('common_for', 'For')} {t('common_shopping', 'shopping')} {t('common_with', 'with')} {t('common_us', 'us')}
                    </Text>

                </View> */}

            </View>

        </Fragment>
    );
};

export default InvoiceFooter;